__turbopack_context__.v({
  "className": "simplifiedchinesenamefont_14ccde93-module__EDTh6a__className",
});
